import React from 'react';
import { Container, Box, Typography, AppBar, Toolbar, Link } from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import FooterSection from '../components/sections/FooterSection';

const facts = [
    { label: 'Beneficjent', value: 'Global Space Spółka z ograniczoną odpowiedzialnością' },
    { label: 'Tytuł projektu', value: 'Wsparcie rozwoju projektu FindSolution.eu' },
    { label: 'Grupa docelowa', value: 'Global Space Spółka z ograniczoną odpowiedzialnością' },
    { label: 'Wartość projektu (łączny koszt)', value: '843 426,00 PLN' },
    { label: 'Wysokość wkładu Funduszy Europejskich', value: '599 964,00 PLN' }
];

const GrantPage = () => {
    const navigate = useNavigate();

    return (
        <Box sx={{ minHeight: '100vh', bgcolor: '#fff', display: 'flex', flexDirection: 'column' }}>
            <AppBar
                position="sticky"
                sx={{
                    bgcolor: 'rgba(255, 255, 255, 0.9)',
                    backdropFilter: 'blur(10px)',
                    boxShadow: '0 2px 20px rgba(0,0,0,0.1)'
                }}
            >
                <Toolbar>
                    <Box
                        onClick={() => navigate('/')}
                        sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                    >
                        <img
                            src="/logo-192x192.png"
                            alt="Find solution Logo"
                            style={{ height: '32px', width: '32px', marginRight: '12px' }}
                        />
                        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#616161' }}>
                            Findsolution.eu
                        </Typography>
                    </Box>
                </Toolbar>
            </AppBar>

            <Container maxWidth="md" sx={{ py: { xs: 5, md: 8 }, flex: 1 }}>
                <Box
                    component="img"
                    src="/eu-dofinansowanie.png"
                    alt="Fundusze Europejskie dla Polski Wschodniej, Rzeczpospolita Polska, Dofinansowane przez Unię Europejską"
                    sx={{ width: '100%', maxWidth: 720, height: 'auto', display: 'block', mb: 5 }}
                />

                <Typography variant="h3" sx={{ fontWeight: 'bold', color: 'grey.800', mb: 2, fontSize: { xs: '2rem', md: '2.6rem' } }}>
                    Dofinansowanie
                </Typography>
                <Typography variant="body1" sx={{ color: 'grey.700', fontSize: '1.1rem', lineHeight: 1.7, mb: 4 }}>
                    Informujemy, że realizujemy projekt dofinansowany ze środków publicznych.
                </Typography>

                <Box component="dl" sx={{ m: 0, mb: 5 }}>
                    {facts.map((fact) => (
                        <Box key={fact.label} sx={{ py: 1.5, borderTop: '1px solid', borderColor: 'grey.200' }}>
                            <Typography component="dt" variant="overline" sx={{ color: 'grey.600', letterSpacing: '0.04em' }}>
                                {fact.label}
                            </Typography>
                            <Typography component="dd" variant="body1" sx={{ m: 0, color: 'grey.900', fontWeight: 600 }}>
                                {fact.value}
                            </Typography>
                        </Box>
                    ))}
                </Box>

                <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'grey.800', mb: 2 }}>
                    Działania i zadania
                </Typography>
                <Typography variant="body1" sx={{ color: 'grey.700', lineHeight: 1.75, mb: 4 }}>
                    Projekt obejmuje rozwój istniejącej wersji MVP platformy FindSolution.eu do pełnej, komercyjnej aplikacji mobilnej (iOS i Android) oraz platformy internetowej. W ramach projektu realizowane będą prace związane z rozbudową architektury systemu, integracją sztucznej inteligencji (AI), wdrożeniem mechanizmów personalizacji, generowania indywidualnych planów działania oraz zapewnienia bezpieczeństwa danych. Projekt obejmuje również testowanie, optymalizację i przygotowanie produktu do komercjalizacji.
                </Typography>

                <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'grey.800', mb: 2 }}>
                    Cel projektu
                </Typography>
                <Typography variant="body1" sx={{ color: 'grey.700', lineHeight: 1.75, mb: 4 }}>
                    Celem projektu jest rozwój działalności biznesowej poprzez opracowanie i wdrożenie innowacyjnej, skalowalnej platformy cyfrowej i dedykowanej aplikacji.
                </Typography>

                <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'grey.800', mb: 2 }}>
                    Rezultaty projektu
                </Typography>
                <Typography variant="body1" sx={{ color: 'grey.700', lineHeight: 1.75, mb: 5 }}>
                    Rezultatem projektu będzie w pełni funkcjonalna aplikacja mobilna FindSolution.eu na systemy iOS i Android oraz platforma internetowa.
                </Typography>

                <Typography variant="body1" sx={{ color: 'grey.800', fontWeight: 700, mb: 2 }}>
                    #FunduszeEuropejskie
                </Typography>
                <Link href="https://www.mapadotacji.gov.pl" target="_blank" rel="noopener noreferrer" sx={{ color: 'primary.main' }}>
                    www.mapadotacji.gov.pl
                </Link>
                <Typography variant="body2" sx={{ color: 'grey.600', mt: 4 }}>
                    <Link component={RouterLink} to="/" underline="hover" sx={{ color: 'grey.700' }}>
                        Wróć na stronę główną
                    </Link>
                </Typography>
            </Container>

            <FooterSection />
        </Box>
    );
};

export default GrantPage;
